import { coordsEqual } from "@/utils/MapUtils";
import axios from "axios";
export const accessToken = "pk.eyJ1IjoiYW5kZXJzd2kiLCJhIjoiY2sxeXZpajg2MGppZDNpbGk0M2k4Ymd1MiJ9.ivUORoF2V8BwTAbi3RTbjQ"; 

export async function matchRoute(coords:number[][]) : Promise<number[][][]> {

	// happens when deleting the last point of a track, the second-to-last should just keep its position.
	if(coords.length == 1) {
		return [coords];
	}

	const coordString = coords.map(c => c.join(",")).join(";")

	const params:any = {
		access_token: accessToken,
		geometries: "geojson",
		radiuses:coords.map(() => "unlimited").join(";")
	};

	const profile = "mapbox/walking";
	try {
		const result = await axios.get(`https://api.mapbox.com/directions/v5/${profile}/${coordString}.json`, {params, timeout:8000});

		if(result.data.routes.length > 0) {
			const rawRoute:number[][] = result.data.routes[0].geometry.coordinates;
			const waypoints = result.data.waypoints.map(w => w.location);
	
	
			const r:number[][][] = waypoints.map((waypoint, index) => {
				if(index == waypoints.length -1)
					return [waypoint];
				const next = waypoints[index+1]
				const ret:number[][] = [];
				ret.push(rawRoute.shift() as number[]);
				while(rawRoute.length && !coordsEqual(rawRoute[0], next))
					ret.push(rawRoute.shift() as number[]);
				return ret;
			});
			return r;
	
		}
		return [coords];
	} catch(error) {
		console.log(error);
		return coords.map(c => [c]);
	}
	
}